import { Directive } from '@angular/core';
import { IfNotSagepayCloudPaymentActiveDirectiveDef } from '@df/module-sagepay';

@Directive({
    selector: '[ifNotSagepayCloudPaymentActive]',
    standalone: true
})
export class IfNotSagepayCloudPaymentActiveDirective extends IfNotSagepayCloudPaymentActiveDirectiveDef {}
